



















































import { Component, Vue } from 'vue-property-decorator';
import SearchQuotation from '@/components/searchQuotation.vue';
import {
  calculateManDay,
  requestGetQuotationCategorys,
  IManDayInfo,
} from '@/utils/quotation';
import { Debounced } from '@/utils/debounced';
import { requestGetSolutions } from '@/utils/solution';

type ISolutionInfo = ISolution.IResponse.ISolutionInfo;
type ISearchSolution = ISolution.IRequest.ISearchSolution;

interface ISelectedQuotation extends IPayment.IQuotationItem {
  radioOption: IManDayInfo;
  type: 1 | 2;
}
const cacheQuotationOption = new Map<string, ISolutionInfo>();
const saveCacheQuotationOption = (data: ISolutionInfo[]) => {
  if (!Array.isArray(data)) {
    return;
  }
  data.forEach((quotation) => {
    cacheQuotationOption.set(quotation.id, quotation);
  });
};

@Component({
  components: {
    SearchQuotation,
  },
})
export default class QuotationForm extends Vue {
  private visible = false;
  private title = '';
  private selectedQuotations: ISelectedQuotation[] = [];
  private fetching: boolean = false;
  private quotationOptions: ISolutionInfo[] = [];

  private debouncedFetchQuotation: (
    searchVal: string,
  ) => void = new Debounced().use(this.searchQuotation, 1000); // 节流函数
  public showModal() {
    this.title = this.$t('payment.addQuotation').toString();
    this.selectedQuotations = [];
    this.visible = true;
  }
  private created() {
    requestGetQuotationCategorys();
  }
  private destroyed() {
    cacheQuotationOption.clear();
  }
  private handleSubmit() {
    const result: IPayment.IQuotationItem[] = this.selectedQuotations.map(
      (quotation) => ({
        quotationId: quotation.quotationId,
        quotationName: quotation.quotationName,
        manDay:
          quotation.type === 1
            ? quotation.radioOption.totalManDay
            : quotation.radioOption.manDay,
      }),
    );
    this.$emit('change', result);
    this.visible = false;
  }
  private handleChange(value: string[]) {
    const cacheQuotationType: { [key: string]: 1 | 2 } = {};
    this.selectedQuotations.forEach((quotation) => {
      cacheQuotationType[quotation.quotationId] = quotation.type;
    });
    const selectedQuotations = [...cacheQuotationOption.values()].filter((option) => value.includes(option.id)) || [];
    this.selectedQuotations = selectedQuotations.map((quotation) => {
      const radioOption = calculateManDay(quotation);
      return {
        quotationId: quotation.id,
        manDay: -1,
        radioOption,
        type: cacheQuotationType[quotation.id]
          ? cacheQuotationType[quotation.id]
          : 1,
        quotationName: quotation.title,
      };
    });
  }
  // 触发搜索需求方法
  private fetchQuotation(searchVal: string) {
    this.debouncedFetchQuotation(searchVal);
  }
  // 请求需求数据
  private searchQuotation(searchVal: string) {
    this.fetching = true;
    const searchTxt = searchVal.trim();
    const params: ISearchSolution = {
      status: 'Approved',
    };
    if (searchTxt) {
      params.title = searchTxt;
    }
    requestGetSolutions(params)
      .then((res) => {
        this.fetching = false;
        this.quotationOptions = res.data;
        saveCacheQuotationOption(res.data);
      })
      .catch((err) => {
        this.fetching = false;
        this.$message.warning(err);
      });
  }
}
